import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
@Component({
  selector: 'app-landing-page-footer',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './landing-page-footer.component.html',
  styleUrl: './landing-page-footer.component.scss',
})
export class LandingPageFooterComponent {
  readonly currentYear = new Date().getFullYear();
}
